import React from 'react';
import { CheckboxField } from 'components/form';
import { useFormContext } from 'react-hook-form';
import { capitalizeFirstLetter } from 'formatters';
import { Box, Stack, Typography } from '@mui/material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { CardSkeleton } from './CardSkeleton';
import { VOFilters, VOFilterType } from '../../types';
import { useFilterOptions } from '../../../../list/api';

export const Tiers = () => {
  const { control } = useFormContext<VOFilters>();

  const { options, loading, error } = useFilterOptions(VOFilterType.TIERS);

  return (
    <RenderWithFallback isLoading={loading && !options.length} error={error} fallBack={<CardSkeleton />}>
      {options.map(({ label, value, meta }) => (
        <CheckboxField
          key={value}
          control={control}
          name={`TIERS.${value}`}
          label={
            <Stack direction="row" gap="0.5rem" alignItems="center">
              <Box
                sx={{
                  width: '1rem',
                  height: '1rem',
                  borderRadius: '100%',
                  border: '1px solid lightgrey',
                  backgroundColor: meta?.color ?? 'black',
                }}
              />

              <Typography>{capitalizeFirstLetter(label)}</Typography>
            </Stack>
          }
        />
      ))}
    </RenderWithFallback>
  );
};
